import pitchDeck from '../assets/Pitchdeck.pdf'

export default function PitchDesk() {
  return (
    <>
      <embed src={pitchDeck} style={{width:'100%',height:'100vh'}}/>
    </>
  )
}